import React from "react";

function PaginationClassic({ rowPerPage, page, setpage, totalDataCount }) {
  const handleNextClick = () => {
    setpage(page + 1);
  };

  const handlePrevClick = () => {
    setpage(page - 1);
  };

  const totalPageCount = Math.ceil((totalDataCount / rowPerPage))

  return (
    <div className={`${!totalDataCount ? 'hidden' : 'flex flex-col sm:flex-row sm:items-center sm:justify-end py-2'}`}>
      <nav
        className="mb-4 sm:mb-0 sm:order-1"
        role="navigation"
        aria-label="Navigation"
      >
        <ul className="flex justify-center items-center">
          <li className="ml-3 first:ml-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              aria-hidden="true"
              role="presentation"
              className={`${
                page === 1
                  ? "fill-current text-slate-400 cursor-not-allowed pointer-events-none"
                  : "cursor-pointer fill-current text-slate-600"
              }`}
              onClick={() => setpage(1)}
            >
              <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
              <path fill="none" d="M24 24H0V0h24v24z"></path>
            </svg>
          </li>
          <li className="ml-3 first:ml-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              aria-hidden="true"
              role="presentation"
              className={`${
                page === 1
                  ? "fill-current text-slate-400 cursor-not-allowed pointer-events-none"
                  : "cursor-pointer fill-current text-slate-600"
              }`}
              onClick={handlePrevClick}
            >
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </li>
          <li className="ml-3 first:ml-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              aria-hidden="true"
              role="presentation"
              className={`${
                Number(totalPageCount) === page || !Number(totalPageCount)
                  ? "fill-current text-slate-400 cursor-not-allowed pointer-events-none"
                  : "cursor-pointer fill-current text-slate-600"
              }`}
              onClick={handleNextClick}
            >
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </li>
          <li className="ml-3 first:ml-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              aria-hidden="true"
              role="presentation"
              className={`${
                Number(totalPageCount) === page || !Number(totalPageCount)
                  ? "fill-current text-slate-400 cursor-not-allowed pointer-events-none"
                  : "cursor-pointer fill-current text-slate-600"
              }`}
              onClick={() => setpage(totalPageCount)}
            >
              <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
              <path fill="none" d="M0 0h24v24H0V0z"></path>
            </svg>
          </li>
        </ul>
      </nav>
      <div className="text-sm text-slate-500 text-center mr-10">
        <span className="font-medium text-slate-600">{1 + ((page - 1) * rowPerPage)}</span> -{" "}
        <span className="font-medium text-slate-600">
          {totalDataCount > (rowPerPage * page) ? (rowPerPage * page) : totalDataCount}
        </span>{" "}
        of <span className="font-medium text-slate-600">{totalDataCount}</span>{" "}
      </div>
    </div>
  );
}

export default PaginationClassic;
